/* eslint-disable max-len */

import { namespace } from 'wsm-tagging-utils';
import dialogAjaxContentLoaded from '../../events/dialog/ajaxContentLoaded';
import dialogPublishDialogAction, {
	CLOSED,
	OPENED
} from '../../events/dialog/publishDialogAction';
import formChange from '../../events/form/change';
import formConfirmation from '../../events/form/confirmation';
import formInitiation from '../../events/form/initiation';
import formOnPage from '../../events/form/onPage';
import formPaymentCalcInit from '../../events/form/paymentCalcInit';
import formSlideChange from '../../events/form/slideChange';
import formSubmission from '../../events/form/submission';
import linkClickToCall from '../../events/link/clickToCall';
import linkClicked from '../../events/link/clicked';
import linkCenterClicked from '../../events/link/centerClicked';
import linkCompare from '../../events/link/compare';
import linkGetDirections from '../../events/link/getDirections';
import linkHproduct from '../../events/link/hproduct';
import linkIncentive from '../../events/link/incentive';
import linkNavigationClick from '../../events/link/navigationClick';
import linkRecommendedVehicle from '../../events/link/recommendedVehicle';
import linkShare from '../../events/link/share';
import linkSocialHeader from '../../events/link/socialHeader';
import linkVehicleCompare from '../../events/link/vehicleCompare';
import maps from '../../events/maps/maps';
import pin from '../../events/map/pin';
import pageFilterSearch from '../../events/page/filterSearch';
import pageFilterSearchClick from '../../events/page/filterSearchClick';
import pageTypedSearch from '../../events/page/typedSearch';
import pageTypedSearchInit from '../../events/page/typedSearchInit';
import pageVehicleDetailView from '../../events/page/vehicleDetailView';
import pageView from '../../events/page/view';
import initialPageWidgetsInView from '../../events/page/initialPageWidgetsInView';
import slideshowClick from '../../events/slideshow/click';
import slideshowPagerClick from '../../events/slideshow/pagerClick';
import videoMilestonesReport from '../../events/video/milestonesReport';
import videoMilestonesTrack from '../../events/video/milestonesTrack';
import getSelectorsToHandle from './selectorsToHandle';
import attachHandlers from './attachHandlers';
import pushEvent from '../pushEvent';
import handleWsTrackingEventListener from './handleWsTrackingEventListener';

const initDataLayerEvents = async (win) => {
	namespace(win, 'DDC.dataLayer.events');

	const {
		DDC,
		DDC: {
			dataLayer,
			dataLayer: { events }
		}
	} = win;

	events.wsTracking = true;

	if (win.$) {
		const $pageBody = $('body');

		namespace(win, 'confirmation', dataLayer);
		namespace(win, 'events', dataLayer);
		namespace(win, 'form', events);
		namespace(win, 'slideshow', events);
		namespace(win, 'link', events);
		namespace(win, 'dialog', events);
		namespace(win, 'page', events);
		namespace(win, 'video', events);
		namespace(win, 'map', events);
		namespace(win, 'milestones', events.video);
		namespace(win, 'video', dataLayer);

		// prettier-ignore
		(function prettierIgnore(){
			events.dialog.ajaxContentLoaded = dialogAjaxContentLoaded.bind(undefined,win);
			events.dialog.closed = dialogPublishDialogAction.bind(undefined, win, CLOSED);
			events.dialog.opened = dialogPublishDialogAction.bind(undefined, win, OPENED);
			events.dialog.publishDialogAction = dialogPublishDialogAction;
			events.form.change = formChange.bind(undefined, win);
			events.form.confirmation = formConfirmation.bind(undefined, win, document);
			events.form.onPage = formOnPage.bind(undefined, win);
			events.form.slideChange = formSlideChange;
			events.link.recommendedVehicle = linkRecommendedVehicle.bind(undefined, win);
			events.link.vehicleCompare = linkVehicleCompare.bind(undefined, win);
			events.maps = maps;
			events.map.pin = pin.bind(undefined, win, document);
			events.page.filterSearch = pageFilterSearch.bind(undefined, win);
			events.page.filterSearchClick = pageFilterSearchClick;
			events.page.vehicleDetailView = pageVehicleDetailView.bind(undefined, win);
			events.page.view = pageView.bind(undefined, win);
			events.page.initialPageWidgetsInView = initialPageWidgetsInView.bind(undefined, win);
			events.slideshow.pagerClick = slideshowPagerClick.bind(undefined, win);
			events.video.milestones.complete = videoMilestonesReport.bind(undefined, 'complete');
			events.video.milestones.report = videoMilestonesReport;
			events.form.initiation = formInitiation.bind(undefined, win);
			events.form.paymentCalcInit = formPaymentCalcInit;
			events.form.submission = formSubmission.bind(undefined, win);
			events.link.clickToCall = linkClickToCall;
			events.link.clicked = linkClicked.bind(undefined, win);
			events.link.centerClicked = linkCenterClicked.bind(undefined, win);
			events.link.compare = linkCompare.bind(undefined, win);
			events.link.getDirections = linkGetDirections;
			events.link.hproduct = linkHproduct.bind(undefined, win, document);
			events.link.incentive = linkIncentive.bind(undefined, win, document);
			events.link.navigationClick = linkNavigationClick.bind(undefined, win);
			events.link.share = linkShare;
			events.link.socialHeader = linkSocialHeader;
			events.page.typedSearch = pageTypedSearch.bind(undefined, win);
			events.page.typedSearchInit = pageTypedSearchInit;
			events.slideshow.click = slideshowClick;
			events.video.milestones.track = videoMilestonesTrack.bind(undefined, win);
			events.video.play = videoMilestonesTrack.bind(undefined,win);
		})();

		// this creates win.DDC.dataLayer.events.selectors = {} if it doesn't exist
		// if it does exist then it is left as is
		namespace(win, 'selectors', events);

		// update win.DDC.dataLayer.events.selectors with the selectorsToHandle
		events.selectors = {
			...win.DDC.dataLayer.events.selectors,
			...getSelectorsToHandle(win)
		};

		// just a shortcut for selectors.xxxx you will see below
		const { selectors } = events;

		handleWsTrackingEventListener(win, document, events);

		$(document).on('marker-clicked-google-maps', (e, marker) => {
			pushEvent(win, events.map.pin(e, marker.infoClass));
		});

		attachHandlers(win, document);

		// Page view events should fire on page document ready.
		pushEvent(win, events.page.view());

		// the setTimeout pattern you see here is a technique to break up long running tasks
		setTimeout(() => {
			pushEvent(win, events.page.vehicleDetailView());
		}, 0);
		setTimeout(() => {
			pushEvent(win, events.page.filterSearch());
		}, 0);
		setTimeout(() => {
			pushEvent(win, events.page.typedSearch());
		}, 0);

		setTimeout(async () => {
			if (DDC.dataLayer.page.pageInfo.isConfirm) {
				const confirmationObject = await events.form.confirmation(
					undefined,
					DDC.dataLayer.page.pageInfo.pageName
				);
				pushEvent(win, confirmationObject);
			}
		}, 0);

		setTimeout(() => {
			if ($pageBody.find(selectors.mapTypeId).length > 0) {
				pushEvent(win, events.maps());
			}
		}, 0);

		setTimeout(() => {
			pushEvent(win, events.page.initialPageWidgetsInView());
		}, 0);

		setTimeout(() => {
			// Page Has Form On Load
			$pageBody.find(selectors.formOnPage).each((_index, element) => {
				pushEvent(win, events.form.onPage(element));
			});
		}, 0);
	}
};

export default initDataLayerEvents;
